// extracted by mini-css-extract-plugin
module.exports = {"AdPageWrapper":"_3uvZwWJRWBia_t0x78O_xW","AdPageWrapperButton":"_3AypN8e0Jzto2s3H3PUD8u"};